export const filterByProperty = ({ data = [], conditions = [] }) => {
    return data?.filter(item => {
        return conditions.every(([key, value]) => item[key] === value);
    });
};

export default filterByProperty;